import DataBlockItem from "@/components/common/DataBlockItem";
import GraphItem from "@/components/common/GraphItem";
import TableItem from "@/components/common/TableItem";
import { Badge } from "@/components/ui/badge";
import SimpleTooltip from "@/components/ui/simple-tooltip";
import AuthContext from "@/store/contexts/AuthContext";
import { GraphConfiguration } from "@/type/common";
import { Info } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DataPreview = ({
  config,
  data,
  metadata,
  error,
}: {
  config: GraphConfiguration;
  data: any;
  metadata?: any;
  error: boolean;
}) => {
  const { t } = useTranslation();
  const [showed, setShowed] = useState(false);
  const { models } = useContext(AuthContext);
  useEffect(() => {
    if (config && config.model !== "") {
      setTimeout(() => {
        setShowed(true);
      }, 600);
    }
  }, [config]);

  if (!showed) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 bottom-0 w-[calc(100%-600px)] bg-transparent flex items-center justify-center">
      <div className="flex flex-col gap-4 w-[600px] max-w-[90%] bg-background p-4 rounded-2xl">
        <div className="w-full">
          <div className="flex flex-row w-full items-center justify-between">
            <span className="font-semibold text-xl">
              {t("editor.preview.title", { type: config.type })}
            </span>
            <Badge>{models.find((m) => m.value === config.model)?.label}</Badge>
          </div>
          <p className="text-muted-foreground">
            {t("editor.preview.description")}
          </p>
        </div>
        <div
          className={
            config.type === "table" ? "h-[400px] relative" : "relative"
          }
        >
          {config.type === "graph" && (
            <GraphItem
              config={config}
              data={data}
              metadata={metadata}
              models={models}
              loaded={true}
            />
          )}
          {config.type === "table" && (
            <TableItem config={config} data={data} models={models} />
          )}
          {config.type === "block" && (
            <DataBlockItem config={config} data={data} />
          )}
          {error && (
            <div className="absolute bottom-4 right-4">
              <Badge variant="destructive">
                {t("editor.preview.loadingError")}
                <SimpleTooltip
                  content={t("editor.preview.loadingErrorTooltip")}
                >
                  <Info size={16} />
                </SimpleTooltip>
              </Badge>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataPreview;
